import type { AxiosInstance } from 'axios';
import { z } from 'zod';

export interface GetAgentSubjectSearchRequest {
  contextIdentifier: string;
  query: string;
  brandIdentifier: string;
  territoryId?: string;
  limit?: number;
  offset?: number;
}

const subjectSearchResponseSchema = z.object({
  results: z.array(
    z.object({
      entityId: z.union([z.number(), z.string()]),
      objectId: z.union([z.number(), z.string()]).optional(),
      name: z.string(),
      type: z.string(),
      link: z.string().optional(),
      subtitle: z.string().optional(),
    })
  ),
});

type SubjectSearchResponse = z.infer<typeof subjectSearchResponseSchema>;

export class ChatContextClient {
  constructor(private authenticatedClient: AxiosInstance) {}

  getContextSubjectSearch = async (data: GetAgentSubjectSearchRequest): Promise<SubjectSearchResponse> => {
    const params = new URLSearchParams({ query: data.query });

    params.set('brandIdentifier', data.brandIdentifier);
    if (data.territoryId) {
      params.set('territoryId', data.territoryId);
    }

    if (data.limit !== undefined) {
      params.set('limit', String(data.limit));
    }
    if (data.offset !== undefined) {
      params.set('offset', String(data.offset));
    }

    const res = await this.authenticatedClient.get<SubjectSearchResponse>(
      `/chat/context/${data.contextIdentifier}/subject-search?${params.toString()}`
    );
    return subjectSearchResponseSchema.parse(res.data);
  };
}
